/* ==========================================================================
   LUX — Background video
   Picks the right source per viewport, starts playback only when the element
   is on screen, and falls back to the poster whenever autoplay is refused.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function chooseSource(video) {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var src = isMobile
      ? video.getAttribute('data-src-mobile')
      : video.getAttribute('data-src-desktop');
    return src || video.getAttribute('data-src-desktop') || '';
  }

  function markReady(video) {
    var wrap = video.closest('[data-lux-video-bg]');
    if (wrap) wrap.classList.add('is-playing');
  }

  function markFallback(video) {
    var wrap = video.closest('[data-lux-video-bg]');
    if (wrap) wrap.classList.add('is-poster-only');
  }

  function load(video) {
    if (video.dataset.luxLoaded === 'true') return;

    var src = chooseSource(video);
    if (!src) { markFallback(video); return; }

    video.dataset.luxLoaded = 'true';
    video.dataset.luxSrc = src;
    video.setAttribute('src', src);

    // Belt and braces: some iOS builds ignore the attribute form.
    video.muted = true;
    video.playsInline = true;

    video.addEventListener('playing', function () { markReady(video); }, { once: true });
    video.addEventListener('error', function () { markFallback(video); }, { once: true });

    video.load();
  }

  function play(video) {
    if (reduceMotion.matches) { markFallback(video); return; }

    load(video);

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Autoplay refused (low power mode, data saver, user setting).
        // The poster stays visible — nothing else to do.
        markFallback(video);
      });
    }
  }

  function pause(video) {
    if (!video.paused) {
      try { video.pause(); } catch (e) { /* ignore */ }
    }
  }

  function init(scope) {
    var videos = (scope || document).querySelectorAll('[data-lux-hero-video]');
    if (!videos.length) return;

    Array.prototype.forEach.call(videos, function (video) {
      // Never burn battery on a video nobody can see.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play(video);
            } else if (video.dataset.luxUserPaused !== 'true') {
              pause(video);
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0.01 });

        io.observe(video);
      } else {
        play(video);
      }

      // Swap the file if the viewport crosses the breakpoint (orientation change).
      var mq = window.matchMedia(MOBILE_QUERY);
      var onChange = function () {
        var next = chooseSource(video);
        if (next && next !== video.dataset.luxSrc) {
          video.dataset.luxLoaded = 'false';
          load(video);
          play(video);
        }
      };

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', onChange);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(onChange);
      }
    });

    // Play / pause control — required for auto-playing motion longer than 5s.
    (scope || document).addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lux-video-toggle]');
      if (!btn) return;

      var target = document.querySelector(btn.getAttribute('data-lux-video-toggle'));
      if (!target) return;

      if (target.paused) {
        target.dataset.luxUserPaused = 'false';
        play(target);
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('is-paused');
      } else {
        target.dataset.luxUserPaused = 'true';
        pause(target);
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.add('is-paused');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
